import { L2_PATHS } from 'Deer/constants/routes';
import { IntentFilters } from 'Deer/intent/components/Layout/IntentFilters.layout';
import { AgGridReact } from 'ag-grid-react';

import { AgGridEllipsisMenu } from 'uiToolkitV1/AgGridWrapperV2/components/EllipsisMenu/AgGridEllipsisMenu';

const intentDropdownOptions = [
  {
    label: 'Compensation Settings',
    onClick: () => {
      console.log('Compensation settings selected');
    },
    category: 'Settings',
    id: 'compensation-settings',
    hasMetaFilters: false,
  },
];

const breadcrumbs = {
  items: [
    {
      label: 'Company',
      to: L2_PATHS.company.overview,
    },
  ],
  page: {
    label: 'Compensation',
    to: '',
  },
};

export const CompensationSettingsHeader = ({ gridRef }: { gridRef: React.RefObject<AgGridReact> }) => {
  const kebabMenuOptions = [
    {
      label: 'Download CSV',
      onClick: () => {
        gridRef.current?.api.exportDataAsCsv();
      },
    },
  ];

  return (
    <IntentFilters
      intentDropdownOptions={intentDropdownOptions}
      selectedIntent={intentDropdownOptions[0].label}
      selectedIntentId={intentDropdownOptions[0].id}
      KebabMenu={<AgGridEllipsisMenu options={kebabMenuOptions} />}
      showKebabMenu
      moduleName=""
      intentTitle=""
      breadcrumbs={breadcrumbs}
      isCategorized={false}
    />
  );
};
